import { useQuery, UseQueryResult } from '@tanstack/react-query';
import TagApiV2 from '../../../../../../lib/api/tag/TagApiV2';
import { TAG } from '../../../../../../constants/queryKeys';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { TagsRelatedFindResponseBodyDto } from '../../../../../../types/api/tags';
import csReviewToastMsg from '../../../../../../constants/service/toastMsg/csReviewToastMsg';

type UseRelatedTagListQuery<SelectResultType> = {
  id: string;
  options?: QueryOptions<TagsRelatedFindResponseBodyDto, unknown, SelectResultType> & {
    meta?: {
      successCallback?: (data: TagsRelatedFindResponseBodyDto) => void;
    };
  };
};

export const useRelatedTagListQuery = <SelectResultType>(
  payload: UseRelatedTagListQuery<SelectResultType>,
): UseQueryResult<SelectResultType, unknown> => {
  const { id, options } = payload;
  return useQuery<TagsRelatedFindResponseBodyDto, unknown, SelectResultType>(
    [...TAG.LIST, id],
    () => TagApiV2.fetchRelateTagList(id),
    {
      ...options,
      enabled: !!id,
      meta: {
        onSuccess: (data: TagsRelatedFindResponseBodyDto) => {
          if (options?.meta?.successCallback) {
            options.meta.successCallback(data);
          }
        },
        errorMessage: csReviewToastMsg.GET_PRODUCT_TAG_LIST_REQUEST_ERROR,
      },
    },
  );
};
